import { useProject } from "@/modules/work/projects/context";
import useRevenue from "./useRevenue";
import { EvtStatsCard as StatsCard } from "components/stats/display-card";
import { EvtStatsCardLoader } from "components/stats/loader";
import { DisplayAmount } from "components/display/amount";
import { formatHoursToTime } from "utils/timesheet";
import { EvtHeader } from "components/header";

export default function ProjectRevenue() {
  const { data, isLoading, error } = useRevenue();

  console.log(data);

  if (isLoading) {
    return (
      <div className="flex-1 p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
          <EvtStatsCardLoader />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex-1 p-6 text-red-500">Error loading revenue data</div>
    );
  }

  return (
    <div className="flex-1">
      <EvtHeader title="Revenue Report" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4  px-6">
        <StatsCard
          label="Contracted Amount"
          value={<DisplayAmount value={data?.contracted_amount} />}
        />
        <StatsCard
          label="Invoiced Amount"
          value={<DisplayAmount value={data?.invoiced_amount} />}
        />
        <StatsCard
          label="Collected Amount"
          value={<DisplayAmount value={data?.collected_amount} />}
        />
        <StatsCard
          label="Spent Hours"
          value={formatHoursToTime(data?.spent_hours)}
        />
        <StatsCard
          label="Consumed Hours"
          value={formatHoursToTime(data?.consumed_hours)}
        />
        <StatsCard
          label="Estimated Hours"
          value={formatHoursToTime(data?.estimated_hours)}
        />
        <StatsCard
          label="Gross Cost"
          value={<DisplayAmount value={data?.gross_cost} />}
        />
        <StatsCard
          label="Net Cost"
          value={<DisplayAmount value={data?.net_cost} />}
        />
        <StatsCard
          label="Net Profit"
          value={<DisplayAmount value={data?.net_profit} />}
        />
      </div>
    </div>
  );
}
